import { render, staticRenderFns } from "./HouseIcon.vue?vue&type=template&id=33752814"
import script from "./HouseIcon.vue?vue&type=script&lang=js"
export * from "./HouseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports